import React from 'react';
import { Stack } from '@grubhubprod/gh-cookbook-react';
import {
  useSetLocationsFormField,
  useRegisterLocationFormField,
} from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/hooks/selectLocationsHooks';
import { LocationsSegmentedControl } from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/LocationsSegmentedControl';
import { LocationsSelectSearch } from 'src/components/oneCorp/features/MealCredit/common/formFields/SelectSearch/LocationsSelectSearch';
import { useSetLocationsExistence } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/hooks/useSetLocationsExistence';

export type SelectLocationsProps = {
  submittedLocationSelections?: { [id: string]: string };
  hasLocation: boolean;
  maxLocationsAllowed: number;
  isActive?: boolean;
};

export const SelectLocations = ({
  submittedLocationSelections,
  hasLocation,
  maxLocationsAllowed,
  isActive = false,
}: SelectLocationsProps): JSX.Element => {
  const { initialLocationsValue } = useSetLocationsFormField(
    submittedLocationSelections
  );

  useSetLocationsExistence({ isActive });

  useRegisterLocationFormField(hasLocation, submittedLocationSelections);

  return (
    <>
      <Stack y={hasLocation ? 'md' : 'none'}>
        <LocationsSegmentedControl
          id="locationsExistence"
          name="locationsExistence"
        />
      </Stack>
      {hasLocation && (
        <LocationsSelectSearch
          maxLocationsAllowed={maxLocationsAllowed}
          name="locations"
          initValue={initialLocationsValue}
        />
      )}
    </>
  );
};
